// services/inquiryService.ts
import {apiClient} from "@/services/client";


export const sendHelpRequest = (form: any) => {
    return apiClient.post(`/communication/send/luxury?site=luxury`,form);
}



// export const submitInquiry = (data: any): Promise<{ success: boolean; message: string }> => {
//     return new Promise((resolve, reject) => {
//         setTimeout(() => {
//             if (!data.email || !data.firstName || !data.message) {
//                 reject({ success: false, message: "Missing required fields." });
//             } else {
//                 resolve({ success: true, message: "Inquiry submitted successfully!" });
//             }
//         }, 3000); // simulate network delay
//     });
// };
